import DevisePasswordsEdit from './DevisePasswordsEdit'

export default DevisePasswordsEdit
